<div class="experience-map" *ngIf="mapUrl">
  <!-- LOADER -->
  <div class="map-loader" *ngIf="isLoading">
    <p-skeleton width="100%" height="500px" styleClass="mb-2"></p-skeleton>
  </div>
  
  <!-- MAP -->
  <div class="map-container" [class.hidden]="isLoading">
    <iframe
      [src]="mapUrl"
      class="google-map-iframe"
      frameborder="0"
      style="border:0"
      allowfullscreen
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
      (load)="onMapLoad()">
    </iframe>
  </div>
  
  <div class="address-wrapper" *ngIf="addressText || directionsUrl">
    <div class="address-text">
      <p *ngIf="addressText">{{ addressText }}</p>
    </div>
    <div class="directions-button" *ngIf="directionsUrl">
      <a 
        class="btn-directions"
        [href]="directionsUrl"
        target="_blank"
        rel="noopener noreferrer">
        Indicazioni stradali
      </a>
    </div>
  </div>
</div>
<div class="map-placeholder" *ngIf="!mapUrl">
  <p>Mappa non disponibile</p>
</div>
